import script from "./Apps.vue?vue&type=script&lang=ts&setup=true"
export * from "./Apps.vue?vue&type=script&lang=ts&setup=true"

import "./Apps.vue?vue&type=style&index=0&id=400e382a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-400e382a"]])

export default __exports__